import { render, staticRenderFns } from "./MediabankImageEdit.vue?vue&type=template&id=656ed46e&"
import script from "./MediabankImageEdit.vue?vue&type=script&lang=js&"
export * from "./MediabankImageEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports